<template src="./html/Edit.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Treeselect from '@riophae/vue-treeselect'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'treeselect': Treeselect,
		},
		data () {
			return {
				modal: {
					selector: 'modal-edit-product-category-' + new Date().getTime(),
				},

				statuses: null,
				categories: null,
				languages: null,
				item: null,
			}
		},
		watch: {
			'item.title'() {
				this.item.slug = this.$options.filters.slugify(this.item.title)
			},
			'item.lang_id'() {
				this.$validator.validateAll()
			},
		},
		created() {
			this.$validator.extend('existsSlugEdit', {
				getMessage: field => 'Título no disponible.',
				validate: (value) => {
					if(value) {
						var data = {
							id: this.item.id,
							slug: this.item.slug,
							lang_id: this.item.lang_id,
						}
						return this.$http.post('admin/management/products/categories/validation/exists', data)
						.then(response => {
							return {
								valid: response.body.valid
							}
						}).catch(function(response) {
							console.log(response)
						})
					} else {
						return false
					}
				}
			});
		},
		methods: {
			open(item) {
				this.item = null
				if(item) {
					this.item = Object.assign({}, item)
				}
				this.init()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			init() {
				this.getStatuses()
				this.getCategories()
				this.getLanguages()
			},
			getStatuses() {
				this.$http.get('admin/statuses')
				.then(response => {
					this.statuses = response.body
				})
			},
			getCategories: function() {
				var data = {
					id: this.item.id
				}
				this.$http.post('admin/management/products/categories/get', data)
					.then(response => {
						this.categories = response.body
					})
			},
			normalizerTreeselectCategory(node) {
				return {
					id: node.id,
					label: node.title,
					children: node.children,
				}
			},
			getLanguages() {
				this.$http.get('languages')
				.then(response => {
					this.languages = response.body
				})
			},
			validate(event) {
				event.stopPropagation()
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.update()
					}
					return result
				})
			},
			update () {
				var btnUpdate = Ladda.create(this.$refs.btnUpdate)
				btnUpdate.start()
				this.$http.put('admin/management/products/categories/' + this.item.id, this.item)
				.then(response => {
					this.close()
					this.$emit('reload')
					btnUpdate.stop()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					console.log(response)
					btnUpdate.stop()
					this.$emit('reload')
					if(response.status == 409) {
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
					}
				})
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/productCategories/views/Edit.vue